<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <button class="close-button" @click="$emit('close')">Закрыть</button>
      <upload-form @uploaded="handleUpload" />
    </div>
  </div>
</template>

<script>
import UploadForm from './UploadForm.vue'; // Импортируем форму загрузки

export default {
  name: 'UploadModal',
  components: {
    UploadForm, // Регистрируем форму загрузки
  },
  methods: {
    handleUpload() {
      this.$emit('close'); // Закрываем модальное окно после загрузки
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  font-family: 'Arial', sans-serif;
}
.close-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #ff4d4d;
  font-size: 16px;
}
</style> 